const configurationStatus = (t, isReady) => {
  if (isReady) return t('CAPTAIN_EXPERIENCE.SCRIPT.STATUS_READY');
  return t('CAPTAIN_EXPERIENCE.SCRIPT.STATUS_CONFIGURE');
};

export const buildAgentSourceCards = ({
  t,
  featureFaq,
  featureMemory,
  approvedResponsesState,
  documentsState,
  memoriesTotalCount,
  scenariosCount,
  availableActionsCount,
  hasAdvancedManagement,
  canManage,
  hasCaptainTools,
}) =>
  [
    {
      title: t('CAPTAIN_EXPERIENCE.AUTO.RESPOSTAS_APROVADAS'),
      description: t('CAPTAIN_EXPERIENCE.SCRIPT.SOURCE_APPROVED_DESCRIPTION'),
      status: featureFaq
        ? approvedResponsesState.status
        : t('CAPTAIN_EXPERIENCE.SCRIPT.STATUS_DISABLED'),
      ready: featureFaq ? approvedResponsesState.ready : false,
      icon: 'i-lucide-message-circle-question',
      routeName: 'captain_assistants_responses_index',
    },
    {
      title: t('CAPTAIN_EXPERIENCE.SCRIPT.SOURCE_DOCUMENTS_TITLE'),
      description: t('CAPTAIN_EXPERIENCE.SCRIPT.SOURCE_DOCUMENTS_DESCRIPTION'),
      status: documentsState.status,
      ready: documentsState.ready,
      icon: 'i-lucide-files',
      routeName: 'captain_assistants_documents_index',
    },
    {
      title: t('CAPTAIN_EXPERIENCE.AUTO.LEMBRANCAS'),
      description: t('CAPTAIN_EXPERIENCE.SCRIPT.SOURCE_MEMORIES_DESCRIPTION'),
      status: featureMemory
        ? configurationStatus(t, memoriesTotalCount > 0)
        : t('CAPTAIN_EXPERIENCE.SCRIPT.STATUS_DISABLED'),
      ready: featureMemory && memoriesTotalCount > 0,
      icon: 'i-lucide-brain',
      routeName: null,
      available: hasAdvancedManagement && canManage,
    },
    {
      title: t('CAPTAIN_EXPERIENCE.SCRIPT.SOURCE_SCENARIOS_TITLE'),
      description: t('CAPTAIN_EXPERIENCE.SCRIPT.SOURCE_SCENARIOS_DESCRIPTION'),
      status: configurationStatus(t, scenariosCount > 0),
      ready: scenariosCount > 0,
      icon: 'i-lucide-route',
      focusId: 'agent-source-scenarios',
      routeName: 'captain_assistants_scenarios_index',
      available: hasAdvancedManagement && canManage,
    },
    {
      title: t('CAPTAIN_EXPERIENCE.SCRIPT.SOURCE_TOOLS_TITLE'),
      description: t('CAPTAIN_EXPERIENCE.SCRIPT.SOURCE_TOOLS_DESCRIPTION'),
      status: canManage
        ? configurationStatus(t, availableActionsCount > 0)
        : t('CAPTAIN_EXPERIENCE.SCRIPT.STATUS_MANAGE'),
      ready: canManage ? availableActionsCount > 0 : null,
      icon: 'i-lucide-wrench',
      focusId: 'agent-source-tools',
      routeName: 'captain_account_tools_index',
      available: hasCaptainTools,
    },
  ].filter(source => source.available !== false);
